module.exports = __webpack_public_path__ + "img/logo.471d1c84.png";